import React, { useState, useEffect } from "react";
import ResignationReasonInput from "../common/ResignationReasonInput";
import { useDispatch, useSelector } from "react-redux";
import "../Resignation/resignationflow.css"

import { DatePicker, Input, Card, Form, Select, Row, Col, Modal, Alert, Spin, Tooltip } from "antd";
import { UploadOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { Button, message, Upload } from "antd";
import moment from "moment";
import Service from "../../service";
import { hideAuthLoader, showAuthLoader } from "../../appRedux/actions";
import useCompanyDateFormat from "../../hooks/useCompanyDateFormat";
const { Option } = Select;

function ResignationFlow({ isVisible, onClose, onSuccess }) {
  const dateFormat = useCompanyDateFormat();
  const dispatch = useDispatch();
  let { authUser } = useSelector(({ auth }) => auth);
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [empdropdown, setEmpDropdown] = useState([]);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
  const [branch, setBranch] = useState("");
  const [noticePeriodDays, setNoticePeriodDays] = useState(null);
  const [noticeLoading, setNoticeLoading] = useState(false);
  const [noticeError, setNoticeError] = useState(null);
  // The date the policy lands on, before it is walked back to a working day.
  const [policyDate, setPolicyDate] = useState(null);

  const [selDate, setSelDate] = useState(null);

  const OnChangeForRequest = (date, dateString) => {
    setSelDate(dateString);
  };

  useEffect(() => {
    getEmpdropdown();
  }, [branch])

  const [lastDate, setLastDate] = useState(null);

  const handleSubmit = (values) => {
    // If the last working day is today, the employee moves to the ex-employee list
    // immediately - confirm before submitting.
    const isSameDayExit = moment(values?.request_last_date)
      .startOf("day")
      .isSame(moment().startOf("day"), "day");

    if (isSameDayExit) {
      Modal.confirm({
        title: "Move employee to ex-employee?",
        content:
          "The selected last working day is today. This employee will be moved to the ex-employee list immediately. Are you sure?",
        okText: "Yes, move to ex-employee",
        cancelText: "Cancel",
        okButtonProps: { danger: true },
        onOk: () => submitResignation(values),
      });
      return;
    }

    submitResignation(values);
  };

  const submitResignation = async (values) => {
    try {
      const formData = new FormData();

      formData.append(
        "last_date",
        moment(values?.request_last_date).format("YYYY-MM-DD")
      );
      formData.append("reason", values?.reason);
      formData.append("comments", values?.comments);
      formData.append("employee_code", String(values?.employee_code));
      fileList.forEach((file) => {
        formData.append("attachment", file.originFileObj);
      });

      dispatch(showAuthLoader());
      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.separationByAdminForUser,
        body: formData,
      });
      dispatch(hideAuthLoader());
      if (response.data && response.data.data && response.data.status === 200) {
        message.success(response.data.message);
        form.resetFields();
        setLastDate(null);
        setFileList([]);
        onClose(); // Close modal on success
        if (onSuccess) {
          onSuccess(); // Call parent success handler if provided
        }
      } else {
        // form.resetFields();
        message.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Notice period is per-employee, so this has to follow the dropdown selection
  // rather than being fetched once on mount. Previously it read the tenant-wide
  // setting, which made employee selection irrelevant to the number shown.
  useEffect(() => {
    const resolveNoticePeriod = async () => {
      setNoticePeriodDays(null);
      setPolicyDate(null);
      setLastDate(null);
      setNoticeError(null);
      if (!selectedEmployeeId) return;

      setNoticeLoading(true);
      try {
        const response = await Service.makeAPICall({
          methodName: Service.postMethod,
          api_url: Service.noticePeriodResolve,
          body: { employee_id: selectedEmployeeId },
        });
        if (response?.data?.status === 200 && response?.data?.data) {
          const resolved = response.data.data;
          setNoticePeriodDays(resolved.days);
          setPolicyDate(moment(resolved.last_date_notice?.raw).format(dateFormat) || null);
          setLastDate(moment(resolved.last_date_notice?.adjusted).format(dateFormat) || null);
        } else {
          setNoticeError(
            response?.data?.message ||
              "Could not determine this employee's notice period."
          );
        }
      } catch (err) {
        setNoticeError("Could not determine this employee's notice period.");
      } finally {
        setNoticeLoading(false);
      }
    };
    resolveNoticePeriod();
  }, [selectedEmployeeId]);

  const disabledDate = (currentDate) => {
    const presentDate = moment().startOf("day");
    return currentDate && !currentDate.isSame(presentDate, "day");
  };

  const textStyle = {
    margin: "10px 0px",
    width: "70%",
    resize: "none",
    marginLeft: "80px",
  };

  const handleFileChange = (info) => {
    console.log("🚀 ~ handleFileChange ~ info:", info);
    let fileList = [...info.fileList];
    setFileList(fileList);
  };

  const getEmpdropdown = async () => {
    try {
      const reqBody = {
        branch: branch ? branch : "none",
      };
      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.empDropdownList,
        body: reqBody,
      });
      if (response.data && response.data.data) {
        const emp = response.data.data;
        setEmpDropdown(emp);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    setLastDate(null);
    setFileList([]);
    onClose();
  };

  return (

    <Modal
      title="Add Resignation"
      open={isVisible}
      onCancel={handleCancel}
      footer={[
        <Button
          key="cancel"
          type="default"
          className="delete-btn"
          onClick={handleCancel}
          style={{ marginRight: "10px" }}
        >
          Cancel
        </Button>,
        <Button
          key="submit"
          data-tour="arf-save"
          type="primary"
          onClick={() => form.submit()}
        >
          Save
        </Button>,
      ]}
      width={800}
      destroyOnClose={true}
    >
      <Form
        className="form-control-group admin-user-resignation"
        onFinish={handleSubmit}
        form={form}
      >
        <div className="main-form-wrapper">
          <div className="form-container">
            {/* Row 1: Date of Resignation & Last Date */}
            <div className="form-row" data-tour="arf-date">
              <div className="form-col">
                <div className="form-item">
                  <Form.Item
                    label="Date of Resignation"
                    name="date_of_resignation"
                    className="search-row"
                    // rules={ [
                    //   {
                    //     required: true,
                    //     message: "Please select date!",
                    //   },
                    // ] }
                    initialValue={moment().startOf("day")}
                  >
                    <p>{moment().startOf("day").format(dateFormat)}</p>
                  </Form.Item>
                </div>
              </div>

              <div className="form-col">
                <div className="form-item">
                  <Form.Item
                    label="Last Date"
                    name="request_last_date"
                    className="search-row"
                    rules={[
                      {
                        required: true,
                        message: "Please select last date!",
                      },
                    ]}
                  >
                    <DatePicker
                      format="DD-MM-YYYY"
                      onChange={OnChangeForRequest}
                      className="fulldate-width"
                    />
                  </Form.Item>
                </div>
              </div>
            </div>

            {/* Row 2: Employee Code & Employee */}
            <div className="form-row" data-tour="arf-employee">
              <div className="form-col">
                <div className="form-item">
                  <Form.Item
                    label="Employee Code"
                    name="employee_code"
                    className="search-row"
                    rules={[
                      {
                        required: true,
                        message: "Please select employee code!",
                      },
                    ]}
                  >
                    <Select
                      defaultValue="Select"
                      size="middle"
                      showSearch
                      className="fulldate-width"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      filterSort={(optionA, optionB) =>
                        optionA.children
                          .toLowerCase()
                          .localeCompare(optionB.children.toLowerCase())
                      }
                      onChange={(e) => {
                        let data = empdropdown.filter(
                          (val) => val.emp_code == e
                        );
                        form.setFieldsValue({
                          employee: data[0]?._id,
                        });
                        setSelectedEmployeeId(data[0]?._id || null);
                      }}
                    >
                      {empdropdown.map((item, index) => (
                        <Option
                          key={index}
                          value={item?.emp_code}
                          style={{ textTransform: "capitalize" }}
                        >
                          {item?.emp_code}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              </div>

              <div className="form-col">
                <div className="form-item">
                  <Form.Item
                    label="Employee"
                    name="employee"
                    className="search-row"
                    rules={[
                      {
                        required: true,
                        message: "Please select employee!",
                      },
                    ]}
                  >
                    <Select
                      defaultValue="Select"
                      size="large"
                      showSearch
                      className="fulldate-width"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      filterSort={(optionA, optionB) =>
                        optionA.children
                          .toLowerCase()
                          .localeCompare(optionB.children.toLowerCase())
                      }
                      onChange={(e) => {
                        let data = empdropdown.filter((val) => val._id == e);
                        form.setFieldsValue({
                          employee_code: data[0]?.emp_code,
                        });
                        setSelectedEmployeeId(e || null);
                      }}
                    >
                      {empdropdown.map((item, index) => (
                        <Option
                          key={index}
                          value={item?._id}
                          style={{ textTransform: "capitalize" }}
                        >
                          {item?.first_name + " " + item?.last_name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              </div>
            </div>

            {/* Notice period resolved for the SELECTED employee - policy or
                company default. Blank until an employee is chosen. */}
            <div className="form-row">
              <div className="form-col">
                <div className="form-item">
                  <Form.Item
                    label={
                      noticePeriodDays != null
                        ? `Last Date As Per Notice Period (${noticePeriodDays} Days)`
                        : "Last Date As Per Notice Period"
                    }
                    className="search-row"
                  >
                    {noticeLoading && <Spin size="small" />}
                    {!noticeLoading && noticeError && (
                      <Alert type="error" showIcon message={noticeError} />
                    )}
                    {!noticeLoading && !noticeError && !selectedEmployeeId && (
                      <p style={{ marginBottom: 0, color: "#8c8c8c" }}>
                        Select an employee to see their notice period
                      </p>
                    )}
                    {!noticeLoading && !noticeError && lastDate && (
                      <p style={{ marginBottom: 0 }}>
                        {lastDate}
                        {policyDate && policyDate !== lastDate && (
                          <Tooltip
                            title={`The notice period ends on ${policyDate}, which is not a working day for this employee's shift. The last working day on or before it is ${lastDate}.`}
                          >
                            <InfoCircleOutlined style={{ marginLeft: 6, color: "#999" }} />
                          </Tooltip>
                        )}
                      </p>
                    )}
                  </Form.Item>
                </div>
              </div>
            </div>

            {/* Row 3: Reason For Resignation */}
            <div className="form-row" data-tour="arf-reason">
              <div className="form-col-full">
                <div className="form-item">
                  <Form.Item
                    label="Reason For Resignation"
                    name="reason"
                    className="search-row"
                    rules={[
                      {
                        required: true,
                        message: "Please select reason!",
                      },
                    ]}
                  >
                    <ResignationReasonInput className="fulldate-width" />
                  </Form.Item>
                </div>
              </div>
            </div>

            {/* Row 4: Comments */}
            <div className="form-row" data-tour="arf-comments">
              <div className="form-col-full">
                <div className="form-item">
                  <Form.Item
                    label="Comments"
                    name="comments"
                    className="search-row"
                    rules={[
                      {
                        required: true,
                        message: "Please enter comments!",
                      },
                    ]}
                  >
                    <Input.TextArea
                      autoSize={{
                        minRows: 5,
                        maxRows: 5,
                      }}
                      style={textStyle}
                    />
                  </Form.Item>
                </div>
              </div>
            </div>

            {/* Row 5: Any Attachments */}
            <div className="form-row">
              <div className="form-col-full">
                <div className="form-item">
                  <Form.Item
                    label="Any Attachments"
                    name="attachments"
                    className="search-row"
                  >
                    <Upload
                      multiple={false}
                      beforeUpload={() => false}
                      onChange={handleFileChange}
                    >
                      <Button icon={<UploadOutlined />}>Click to Upload</Button>
                    </Upload>
                  </Form.Item>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </Modal>

  );
}

export default ResignationFlow;